export const envType =
  window.location.hostname === "mynexity-ngip.nexity.fr"
    ? "prod"
    : window.location.hostname.split(".")[0];
